import app from './../../../scripts/app';
import { switchToHomeowner } from '../../../../../shared/api/switchToHomeowner';
import { isBaseAndProfiFrozen } from '../../../../../shared/utils';
import { camelToDash } from '../../../scripts/utils';
import { trackPubAvailPopupAction } from './PubAvail.tracking';
import { setIdentificationCookies } from './utils/setIdentificationCookies';
import { HOMEOWNER_AND_NEED_IDENTIFICATION } from '../../../scripts/services/pub-avail.service';
import { selectIsByHomeowner } from '../../../../../shared/selectors/offer';

const templates = require.context('./templates', true, /\.tpl\.jade$/);
templates.keys().map(templates);

app.directive('cianAfPubAvail', [
  'httpApi',
  'logger',
  'store',
  function (httpApi, logger, store) {
    return {
      restrict: 'E',
      scope: {},
      bindToController: {
        data: '=',
        onContinue: '&?',
        ad: '=',
      },
      controllerAs: 'pubAvail',
      template: '<ng-include src="pubAvail.getTemplateUrl()"></ng-include>',
      controller(deviceService, geoService, config) {
        'ngInject';

        this.isMobile = deviceService.isMobile;

        this.protectionIcon = require('./assets/protection.png');

        this.getTemplateUrl = () => {
          const state = store.getState();
          const isByHomeowner = selectIsByHomeowner(state);

          const { windowModeType, identificationInstruction } = this.data;

          const isAgent = !isByHomeowner;

          if (!windowModeType) {
            return;
          }

          if (
            windowModeType === HOMEOWNER_AND_NEED_IDENTIFICATION &&
            identificationInstruction?.onlyDocumentsAllowed &&
            isAgent
          ) {
            return 'blocks/segments/pub-avail/templates/identification-commercial.tpl.jade';
          }

          const templateName = `${camelToDash(windowModeType)}.tpl.jade`;

          return `blocks/segments/pub-avail/templates/${templateName}`;
        };

        const sendAnalytics = action => {
          trackPubAvailPopupAction(this.data.windowModeType, action);
        };

        this.onIdentification = () => {
          sendAnalytics('GoIdentification');
          setIdentificationCookies();

          const url = this.data.identificationInstruction.identificationUrl;
          window.open(url, '_blank');
        };

        this.onIdentificationHomeowner = () => {
          const w = window.open('', '_blank');
          switchToHomeowner({ httpApi, logger }, { locationPath: geoService.getLocationPath() })
            .catch(() => {})
            .then(() => {
              w.location = this.data.identificationInstruction.identificationUrl;
            });
        };

        this.onSelectTariff = () => {
          sendAnalytics('SelectTariff');
        };

        this.onPay = () => {
          sendAnalytics('Pay');
        };

        this.onContinueBtn = () => {
          sendAnalytics('Continue');
          this.onContinue();
        };

        // ViewAlert только для попапа
        if (this.onContinue) {
          sendAnalytics('ViewAlert');
        }

        this.isTariffsFrozen = () => isBaseAndProfiFrozen({ config, geoService });

        this.getTitleNeedCommercial = () => {
          if (this.isTariffsFrozen()) {
            return 'Необходимо активировать Тариф с подпиской';
          }

          if (this.data.profiAvailable) {
            return 'Необходимо активировать тариф «Базовый» или «Профи»';
          }

          return 'Необходимо активировать тариф «Базовый»';
        };

        this.getTitleOnCommercialDepositRequired = () => {
          if (this.isTariffsFrozen()) {
            return 'Перейдите на Тариф с подпиской';
          }

          return `Перейдите на тариф «Базовый ${this.data.regionName}»`;
        };
      },
    };
  },
]);
